export default {
  cardPack: 'Card pack',
  cardsSuffix: ' cards',
  notFound: 'No cards found',
  fullCollectionReward: 'Full collection reward',
  canFind: 'This card can be found in the following packs',
  cannotFind: 'This card cannot be found in your currently available packs',
  active: 'Active cards',
  equipped: 'cards equipped',
  onActive: 'when active',
  onDuplicate: 'on duplicate',
  activeDescription: 'Duplicate cards can be equipped, and will be consumed on next prestige to activate their effects. These effects stay active until you prestige again.',
  equipTutorial: {
    description: 'You collected your first cards! Most cards have an effect when active, to enable it you have to do the following:',
    1: 'Collect a duplicate of a card',
    2: 'Unlock prestige for one of your main features',
    3: 'Go to the prestige menu and equip the duplicate card (must be the same feature as seen at the bottom right of the card)',
    4: 'Perform a prestige with the card equipped',
    5: 'The card will get consumed and its effects are active until you prestige again'
  },
  card: {
    'MI-0001': 'Basic equipment',
    'MI-0002': 'Unused pickaxe',
    'MI-0003': 'Pickaxe crate',
    'MI-0004': 'Light the fuse!',
    'MI-0005': 'Into the depths',
    'MI-0006': 'Helmet shelf',
    'MI-0007': 'Take cover!',
    'MI-0008': 'Working hard',
    'MI-0009': 'Pick or shovel?',
    'MI-0010': 'Too small',
    'MI-0011': 'Motivated worker',
    'MI-0012': 'Workplace accident',
    'MI-0013': 'Temporary storage',
    'MI-0014': 'Filled crate',
    'MI-0015': 'To the surface',
    'MI-0016': 'Extraction',
    'MI-0017': 'Transport',
    'MI-0018': 'Quality control',
    'MI-0019': 'Recycling factory',
    'MI-0020': 'Hydraulic press',
    'MI-0021': 'Refining experiment',
    'MI-0022': 'Robot assembly',
    'MI-0023': 'Stuck pickaxe',
    'MI-0024': 'Mine entrance',
    'MI-0025': 'Detonate rock pile',
    'MI-0026': 'Mineshaft',
    'MI-0027': 'Surface rock',
    'MI-0028': 'Disturbing the bats',
    'MI-0029': 'Creepy crawly',
    'MI-0030': 'Rare find',
    'MI-0031': 'Underground lake',
    'MI-0032': 'Flammable liquid',
    'MI-0033': 'Underground cemetery',
    'MI-0034': 'Lurking spider',
    'MI-0035': 'No way out',
    'MI-0036': 'Earthquake',
    'MI-0037': 'Toxic gas',
    'MI-0038': 'Crystal spikes',

    'VI-0001': 'Massive boulders',
    'VI-0002': 'Hidden gem',
    'VI-0003': 'Dripstone cave',
    'VI-0004': 'Two paths',
    'VI-0005': 'Cave flowers',
    'VI-0006': 'Outside camping',
    'VI-0007': 'Playground',
    'VI-0008': 'Quiet area',
    'VI-0009': 'Angry neighbor',
    'VI-0010': 'House with garden',
    'VI-0011': 'Build a home',
    'VI-0012': 'Camping trip',
    'VI-0013': 'Living room',
    'VI-0014': 'Dog house',
    'VI-0015': 'Roof garden',
    'VI-0016': 'Century tree',
    'VI-0017': 'Tree theft',
    'VI-0018': 'Community garden',
    'VI-0019': 'Reforesting',
    'VI-0020': 'Deforesting',
    'VI-0021': 'Log truck',
    'VI-0022': 'Research lab',
    'VI-0023': 'Experiment',
    'VI-0024': 'Disease analysis',
    'VI-0025': 'Forming bars',
    'VI-0026': 'Nail factory',
    'VI-0027': 'Old library',
    'VI-0028': 'Clockwork',
    'VI-0029': 'Cooking robot',
    'VI-0030': 'Remote garage',
    'VI-0031': 'Generator',
    'VI-0032': 'Solar panels',
    'VI-0033': 'Self-driving car',
    'VI-0034': 'Firefighters',
    'VI-0035': 'Police station',
    'VI-0036': 'Lighting the way',
    'VI-0037': 'Saving a dog',
    'VI-0038': 'Ambulance',
    'VI-0039': 'Lifeguard',

    'HO-0001': 'Lurking snake',
    'HO-0002': 'Deep hole',
    'HO-0003': 'Erupting volcano',
    'HO-0004': 'Lost',
    'HO-0005': 'Frozen forever',
    'HO-0006': 'Magma chamber',
    'HO-0007': 'Backpack check',
    'HO-0008': 'Wall construction',
    'HO-0009': 'Surveillance camera',
    'HO-0010': 'Mushroom guide',
    'HO-0011': 'Electric fence',
    'HO-0012': 'Megabomb',
    'HO-0013': 'Rocket launcher',
    'HO-0014': 'Sworderang',
    'HO-0015': 'Poisoned arrow',
    'HO-0016': 'Guided missile',
    'HO-0017': 'Axe thrower',
    'HO-0018': 'Mighty pen',
    'HO-0019': 'Catapult',
    'HO-0020': 'Gunblade',
    'HO-0021': 'Sun rays',
    'HO-0022': 'Sawblade launcher',
    'HO-0023': 'Supercorrosive',
    'HO-0024': 'Natural cover',
    'HO-0025': 'Forest meditation',
    'HO-0026': 'Metal detector',
    'HO-0027': 'Projectile shield',
    'HO-0028': 'Force field',
    'HO-0029': 'Radar',
    'HO-0030': 'Spy',
    'HO-0031': 'Corruption not allowed',
    'HO-0032': 'Liquid filter',
    'HO-0033': 'Washing machine',
    'HO-0034': 'Kill it with fire',
    'HO-0035': 'Purification beam',
    'HO-0036': 'Stomp the corruption',
    'HO-0037': 'Into the trash!',
    'HO-0038': 'Strange ritual',
    'HO-0039': 'Vacuum cleaner',
    'HO-0040': 'Power of science',
    'HO-0041': 'Just microwave it',

    'FA-0001': 'Picking apples',
    'FA-0002': 'Pumpkin contest',
    'FA-0003': 'Flower shop',
    'FA-0004': 'Office plant',
    'FA-0005': 'Scarecrow',
    'FA-0006': 'Artificial rain',
    'FA-0007': 'Supply train',
    'FA-0008': 'Food transport',
    'FA-0009': 'Warm greenhouse',
    'FA-0010': 'Fruit smoothie',
    'FA-0011': 'Bakery sale',
    'FA-0012': 'Ice cream truck',
    'FA-0013': 'Fast food order',
    'FA-0014': 'Feast',
    'FA-0015': 'Candyland',
    'FA-0016': 'Tea time',
    'FA-0017': 'Making wine',
    'FA-0018': 'Cookie and coffee',
    'FA-0019': 'Orange veggies',
    'FA-0020': 'Spicy-fruity red',
    'FA-0021': 'Daisy yellow',
    'FA-0022': 'Plant green',
    'FA-0023': 'Blueberry bush',
    'FA-0024': 'Purple mushrooms',
    'FA-0025': 'Bug powder',
    'FA-0026': 'Fresh lime',
    'FA-0027': 'Butterfly wings',

    'GA-0001': 'Ladybugs',
    'GA-0002': 'Colorful feathers',
    'GA-0003': 'Making lemonade',
    'GA-0004': 'Algae',
    'GA-0005': 'Art museum',
    'GA-0006': 'Pencil drawing',
    'GA-0007': 'Pen collection',
    'GA-0008': 'Spray painting',
    'GA-0009': 'Color palette',
    'GA-0010': 'Wall painting',
    'GA-0011': 'Artist signature',
    'GA-0012': 'Mixing paint',
    'GA-0013': 'Modern art auction',
    'GA-0014': 'Portrait',
    'GA-0015': 'Recycling bin',
    'GA-0016': 'Pizza delivery',
    'GA-0017': 'Package delivery',
    'GA-0018': 'School bus',
    'GA-0019': 'Drum factory',
    'GA-0020': 'Cargo ship',
    'GA-0021': 'Moving company',
    'GA-0022': 'Drone delivery',
    'GA-0023': 'Tow truck',

    'GE-0001': 'Ruby railway',
    'GE-0002': 'Emerald mine',
    'GE-0003': 'Sunken treasure',
    'GE-0004': 'Luxury watch',
    'GE-0005': 'Dangerous triangles',
    'GE-0006': 'Diamond tools',
    'GE-0007': 'Security measures',

    'EV-0001': 'Fair',
    'EV-0002': 'Building competition',
    'EV-0003': 'Grill',
    'EV-0004': 'Birthday party',
    'EV-0005': 'Yard sale',
    'EV-0006': 'Gas station',
    'EV-0007': 'Local merchant',
    'EV-0008': 'Bingo on TV',
    'EV-0009': 'Casino',
    'EV-0010': '???',
    'EV-0011': 'Bank safe',
    'EV-0012': 'Profit!',
    'EV-0013': 'Credit card',
    'EV-0014': 'Desert',
    'EV-0015': 'Paragliding',
    'EV-0016': 'Jungle mystery',
    'EV-0017': 'Stranded turtle',
    'EV-0018': 'Flower breeding',
    'EV-0019': 'Plant sample',
    'EV-0020': 'Spearfishing',
    'EV-0021': 'Snail race',
    'EV-0022': 'Lonely island',
    'EV-0023': 'Summer song',
    'EV-0024': 'Cozy couch',
    'EV-0025': 'Nasty mountain',
    'EV-0026': 'Nighttime city',
    'EV-0027': 'Hot apple juice',
    'EV-0028': 'Mysterious soup',
    'EV-0029': 'Secret spring',
    'EV-0030': 'Build a snowman',
    'EV-0031': 'Winter sports',
    'EV-0032': 'Castle lights',
    'EV-0033': 'Lightbulb store',

    'XD-1337': 'Testing card'
  },
  collection: {
    minersAndEquipment: 'Miners and equipment',
    scrapLogistics: 'Scrap logistics',
    caveLocations: 'Cave locations',
    dangersInTheDark: 'Dangers in the dark',
    neighborhood: 'Neighborhood',
    plantsInTheCity: 'Plants in the city',
    industrialRevolution: 'Industrial revolution',
    maintainingSafety: 'Maintaining safety',
    dangerousWeapons: 'Dangerous weapons',
    supplyAndSupport: 'Supply and support',
    againstTheCorruption: 'Against the corruption',
    feedingTheWorld: 'Feeding the world',
    organicDyes: 'Organic dyes',
    artDisplay: 'Art display',
    deliveryService: 'Delivery service',
    preciousJewelry: 'Precious jewelry',
    weekendTrip: 'Weekend trip',
    tropicalParadise: 'Tropical paradise',
    coldTimes: 'Cold times',
  },
  pack: {
    intoDarkness: 'Into darkness',
    drillsAndDepths: 'Drills and depths',
    hotStuff: 'Hot stuff',
    dangerZone: 'Danger zone',
    meetingNewPeople: 'Meeting new people',
    darkCult: 'Dark cult',
    technologicalAdvancement: 'Technological advancement',
    rookieOnTheBattlefield: 'Rookie on the battlefield',
    spiritualSuccess: 'Spiritual success',
    oldMemories: 'Old memories',
    taintedWorld: 'Tainted world',
    bountifulHarvest: 'Bountiful harvest',
    juicyYields: 'Juicy yields',
    insectWorld: 'Insect world',
    beesAndFlowers: 'Bees and flowers',
    newArtist: 'New artist',
    inspiringCreations: 'Inspiring creations',
    goodDeal: 'Good deal',
    connectedLine: 'Connected line',
    feelingLucky: 'Feeling lucky',
    investorsDream: 'Investors dream',
    greenThumb: 'Green thumb',
    fishingForFun: 'Fishing for fun',
    charmingShip: 'Charming ship',
    midnightAnomaly: 'Midnight anomaly',
    icyWonderland: 'Icy wonderland',
    sparksOfJoy: 'Sparks of joy',
  }
};
